import { ComponentType, lazy } from "react";

const LandingPage = lazy(() => import("../pages/LandingPage/LandingPage"));
const LoginPage = lazy(() => import("../pages/LoginPage/LoginPage"));
const RegisterPage = lazy(() => import("../pages/RegisterPage/RegisterPage"));
const ForgotPasswordPage = lazy(
  () => import("../pages/ForgotPasswordPage/ForgotPasswordPage"),
);
const ResetPasswordPage = lazy(
  () => import("../pages/ResetPasswordPage/ResetPasswordPage"),
);
const HomePage = lazy(() => import("../pages/HomePage/HomePage"));
const QuizPage = lazy(() => import("../pages/QuizPage/QuizPage"));
const LeaderBoardPage = lazy(
  () => import("../pages/LeaderBoardPage/LeaderBoardPage"),
);
const ProfilePage = lazy(() => import("../pages/ProfilePage/ProfilePage"));
const SettingsPage = lazy(() => import("../pages/SettingsPage/SettingsPage"));
const ShopPage = lazy(() => import("../pages/ShopPage/ShopPage"));
const MinigamesPage = lazy(
  () => import("../pages/MinigamesPage/MinigamesPage"),
);

export interface Routes {
  path: string;
  page: ComponentType;
  isPrivate: boolean;
}

export const routes: Routes[] = [
  {
    path: "/",
    page: LandingPage,
    isPrivate: false,
  },
  {
    path: "/login",
    page: LoginPage,
    isPrivate: false,
  },
  {
    path: "/register",
    page: RegisterPage,
    isPrivate: false,
  },
  {
    path: "/forgot-password",
    page: ForgotPasswordPage,
    isPrivate: false,
  },
  {
    path: "/reset-password",
    page: ResetPasswordPage,
    isPrivate: false,
  },
  {
    path: "/home",
    page: HomePage,
    isPrivate: true,
  },
  {
    path: "/quiz/:quizId",
    page: QuizPage,
    isPrivate: true,
  },
  {
    path: "/leaderboard",
    page: LeaderBoardPage,
    isPrivate: true,
  },
  {
    path: "/profile",
    page: ProfilePage,
    isPrivate: true,
  },
  {
    path: "/settings",
    page: SettingsPage,
    isPrivate: true,
  },
  {
    path: "/shop",
    page: ShopPage,
    isPrivate: true,
  },
  {
    path: "/minigames",
    page: MinigamesPage,
    isPrivate: true,
  },
];

export const isPublicRoute = (path: string): boolean => {
  const sortedRoutes = [...routes].sort((a, b) => {
    if (a.path === path && b.path !== path) return -1;
    if (b.path === path && a.path !== path) return 1;
    return b.path.length - a.path.length;
  });

  const route = sortedRoutes.find((r) => {
    if (r.path === path) return true;

    if (r.path.includes(":")) {
      const basePath = r.path.split(":")[0];
      return path.startsWith(basePath);
    }

    return path.startsWith(r.path + "/");
  });
  return route ? !route.isPrivate : false;
};

export const isPrivateRoute = (path: string): boolean => {
  const sortedRoutes = [...routes].sort((a, b) => {
    if (a.path === path && b.path !== path) return -1;
    if (b.path === path && a.path !== path) return 1;
    return b.path.length - a.path.length;
  });

  const route = sortedRoutes.find((r) => {
    if (r.path === path) return true;

    if (r.path.includes(":")) {
      const basePath = r.path.split(":")[0];
      return path.startsWith(basePath);
    }

    return path.startsWith(r.path + "/");
  });
  return route ? route.isPrivate : false;
};
